import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'

const ItemTypes = {
  CARD: 'card',
}

const style = {
  border: '1px dashed gray',
  padding: '0.5rem 1rem',
  marginBottom: '.5rem',
  backgroundColor: 'white',
  cursor: 'move',
}

export const PageReorderCard = ({ id, imageYN, textYN, richTextYN, htmlYN, linkYN, singleChoiceYN, pronounceYN, fileURL, fileTextBr, text, index, moveCard, saveCards }) => {
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
	drop(item, monitor) {
      if (!ref.current) {
        return
      }
	  saveCards();
	},
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0 : 1
  drag(drop(ref))
  return (
	<div>
		{imageYN && (<div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
			<img 
				className="PageReorderImage"
				src={fileURL}
				border="0"
			/>
		</div>)}
		{textYN && (<div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
			<div className="PageReorderText">
				{fileTextBr}
			</div>
		</div>)}
		{richTextYN && (<div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
				<iframe
					className="PageReorderRichText"
					src={fileURL}
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
					title="html"
				/>
		</div>)}
		{htmlYN && (<div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
				<iframe
					className="PageReorderHtml"
					src={fileURL}
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
					title="html"
				/>
		</div>)}
		{linkYN && (<div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
			<div className="PageReorderLink">
				{fileTextBr}
			</div>
		</div>)}
		{singleChoiceYN && (<div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
			<div className="PageReorderSingleChoice">
				{fileTextBr}
			</div>
		</div>)}
		{pronounceYN && (<div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
			<div className="PageReorderPronounce">
				{fileTextBr}
			</div>
		</div>)}
	</div>
  )
}
